import React, { useState } from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel'
import * as Icon from 'react-bootstrap-icons';
import { Redirect } from 'react-router-dom';

export const ImageCarousel = () => {

  const [redirect, setRedirect] = useState(false)


  const headerImageSrc = 'https://firebasestorage.googleapis.com/v0/b/nutrition-outreach.appspot.com/o/IMG_4533.jpeg?alt=media&token=86e1fd6b-c1eb-4bc3-adf8-70dbca67fdfe'

  function takeSurvey() {
    setRedirect(true)
  }

  return (

    <>
      {redirect === false ?
        <Card className='shadow-4-strong p-0'>
          <Card.Body className='p-0'>
            <Carousel controls={false}>
              <Carousel.Item >
                <img
                  className='p-0'
                  style={{ height: "calc(600px)", width: '100%', objectFit: 'cover', marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
                  src={headerImageSrc}
                  alt="First slide"
                />
                <Carousel.Caption>
                  <Button onClick={takeSurvey}>Take Our Survey</Button>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Card.Body>
        </Card>
        : <Redirect to='/survey' />
      }
    </>
  )
}

